import React, { useEffect, useState } from 'react';
import { userApi } from '../api/axios';
import { persistAccessToken, getStoredAccessToken } from '../api/authSession';
import { markBrowserAuthSession } from '../shared/utils/authPersistence';
import { clearGuestSpectatorSessionState } from '../shared/utils/guestSpectatorSession';

const NH_ORIGIN = String(process.env.REACT_APP_NIGHT_HOUSE_ORIGIN || '').trim().replace(/\/$/,'');
const TRY_KEY = 'nh:sso:auto-try';
const SSO_MESSAGES = {
  SSO_NOT_CONFIGURED:'SSO connection is not configured on the NPC lobby server.',
  SSO_SERVICE_UNAVAILABLE:'The Night House SSO server is unavailable. Please check that Night House is running.',
  SSO_EXPIRED_OR_USED:'This sign-in link has expired or was already used. Please try entering NPC from Night House again.',
  ALREADY_LOGGED_IN:'This account is currently logged in through another NPC browser or tab.',
  LOGIN_IN_PROGRESS:'Another login is in progress. Please try entering NPC again.',
  LOGIN_SESSION_CHECK_FAILED:'NPC session storage is temporarily unavailable.',
  ACCOUNT_UNAVAILABLE:'Your NPC account is not available.',
  INVALID_SSO_CODE:'The sign-in link is invalid. Please try entering NPC from Night House again.',
};
function safeNext(next) {
  try {
    const url = new URL(next || '/lobby', window.location.origin);
    return url.origin === window.location.origin && url.pathname !== '/nh-sso' ? url.pathname+url.search : '/lobby';
  } catch (_) { return '/lobby'; }
}

// Only navigate when auto-SSO is configured. Stop loops on unauthenticated NH sessions.
export function NightHouseSsoAuto() {
  useEffect(() => {
    if (!/^https?:\/\//i.test(NH_ORIGIN)) return;
    const path=window.location.pathname;
    if (!(path==='/' || path==='/login' || path==='/lobby' || path.startsWith('/lobby/'))) return;
    if (window.location.search.includes('nh_sso=guest') || window.location.search.includes('guestLogin=1')) return;
    if (getStoredAccessToken()) return;
    const last = Number(sessionStorage.getItem(TRY_KEY) || 0);
    if (Date.now() - last < 5 * 60 * 1000) return;
    sessionStorage.setItem(TRY_KEY, String(Date.now()));
    const dest = new URL('/api/auth/sso/bridge', NH_ORIGIN);
    dest.searchParams.set('return_to', window.location.origin+window.location.pathname+window.location.search);
    window.location.replace(dest.toString());
  }, []);
  return null;
}

export function NightHouseSsoEntry() {
  const [msg,setMsg] = useState('Connecting your Night House account…');
  useEffect(() => {
    const fragment = new URLSearchParams(window.location.hash.slice(1));
    const code = fragment.get('code') || '';
    const next = safeNext(fragment.get('next'));
    // Immediately wipe the fragment from history.
    window.history.replaceState(null,'','/nh-sso');
    if (!code) {window.location.replace('/login?nh_sso=guest');return;}
    let cancelled = false;
    (async () => {
      try {
        const {data} = await userApi.post('/sso/night-house/redeem',{code},{__npcSkipAuthRefresh:true});
        if (cancelled) return;
        if (!data?.token || !data?.session_id) throw Error('Missing authentication session');
        clearGuestSpectatorSessionState({reason:'night_house_sso'});
        persistAccessToken(data.token,data.session_id);
        localStorage.removeItem('user_code');localStorage.removeItem('userCode');
        const u = data.user || {};
        localStorage.setItem('user',JSON.stringify({...u,user_code:String(u.user_code||''),User_code:String(u.user_code||'')}));
        markBrowserAuthSession({autoLogin:true});
        sessionStorage.removeItem(TRY_KEY);
        window.location.replace(next);
      } catch(e) {
        if(cancelled)return;
        const errorCode = String(e?.response?.data?.error || '').trim();
        const detail = String(e?.response?.data?.message || '').trim();
        const message = detail || SSO_MESSAGES[errorCode] || (e?.response ? 'Night House automatic login failed. Please sign in to NPC.' : 'Cannot connect to the NPC lobby API. Check that the lobby server is running.');
        setMsg(errorCode ? `${message} (${errorCode})` : message);
      }
    })();
    return () => {cancelled=true;};
  }, []);
  return <main style={{minHeight:'100vh',background:'#090909',color:'#fff',display:'grid',placeItems:'center',fontFamily:'sans-serif',textAlign:'center',padding:30}}><div><h2>NIGHT HOUSE × NIGHT POKER CLUB</h2><p>{msg}</p><a style={{color:'#f3bd74'}} href="/login?nh_sso=guest">Sign in manually</a></div></main>;
}
